import { useState, useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router'
import GridWebhooks from '../components/grid-webhooks'
import Modal from '../components/modal'
import NavBarWebhooks from '../components/nav-bar-webhooks'
import TopBarWebhooks from '../components/top-bar-webhooks'
import CreateWebhook from '../module/create-webhook'
import { ToastContainer, toast } from 'react-toastify'
import API from '../hooks/requests'
import EditWebhook from '../module/edit-webhook'

const WebhooksPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [createWebhook, setCreateWebhook] = useState(false)
  const [editWebhook, setEditWebhook] = useState(null)
  const [pipelineGet, setPipelineGet] = useState('')
  const [pipelineNameGet, setPipelineNameGet] = useState('')
  const [keyGet, setKeyGet] = useState('')
  const [toastID, setToastID] = useState(null)
  const [dataList, setDataList] = useState([])

  const closeCreate = () => {
    setCreateWebhook(false)
    setPipelineGet('')
    setKeyGet('')
    setPipelineNameGet('')
  }

  const closeEdit = () => {
    setEditWebhook(null)
    setPipelineGet('')
    setKeyGet('')
    setPipelineNameGet('')
    setToastID(null)
    toast.dismiss()
  }

  const refreshEdit = () => {
    setPipelineGet('')
    setKeyGet('')
    setPipelineNameGet('')
  }

  useMemo(() => {
    const filter = searchParams.get('filter')
    const search = searchParams.get('search')
    if (filter && search) {
      API.getWebhooksList(filter, search)
        .then((r) => {
          setDataList(r.data.data)
        })
        .catch((e) => console.log(e))
    } else if (search) {
      API.getWebhooksList('all', search)
        .then((r) => {
          setDataList(r.data.data)
        })
        .catch((e) => console.log(e))
    } else if (filter) {
      API.getWebhooksList(filter)
        .then((r) => {
          setDataList(r.data.data)
        })
        .catch((e) => console.log(e))
    } else {
      API.getWebhooksList()
        .then((r) => {
          setDataList(r.data.data)
        })
        .catch((e) => console.log(e))
    }
  }, [searchParams])

  useEffect(() => {
    API.getWebhooksList()
      .then((r) => {
        setDataList(r.data.data)
      })
      .catch((e) => console.log(e))
  }, [])

  return (
    <div className="webhooks">
      <ToastContainer
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={true}
        pauseOnFocusLoss={false}
      />
      <Modal
        status={createWebhook}
        close={closeCreate}
        children={
          <CreateWebhook
            createWebhook={createWebhook}
            pipelineGet={pipelineGet}
            setPipelineGet={setPipelineGet}
            pipelineNameGet={pipelineNameGet}
            setPipelineNameGet={setPipelineNameGet}
            keyGet={keyGet}
            setKeyGet={setKeyGet}
            close={closeCreate}
            toast={toast}
            setDataList={setDataList}
          />
        }
      />
      <Modal
        status={editWebhook}
        close={closeEdit}
        children={
          <EditWebhook
            editWebhook={editWebhook}
            close={closeEdit}
            pipelineGet={pipelineGet}
            setPipelineGet={setPipelineGet}
            pipelineNameGet={pipelineNameGet}
            setPipelineNameGet={setPipelineNameGet}
            keyGet={keyGet}
            setKeyGet={setKeyGet}
            toast={toast}
            setDataList={setDataList}
            toastID={toastID}
            setToastID={setToastID}
            refresh={refreshEdit}
          />
        }
      />
      <TopBarWebhooks callback={setCreateWebhook} />
      <NavBarWebhooks
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
      <GridWebhooks
        dataList={dataList}
        toast={toast}
        setEditWebhook={setEditWebhook}
      />
    </div>
  )
}

export default WebhooksPage
